<div class="legs">
    @for (leg of marketLegs; track $index) {
        <div class="market-leg">
            <div class="circle-overlay">
                <vn-icon size="8" name="theme-radio-off" />
            </div>
            <span class="leg">{{ leg }}</span>
        </div>
    }
</div>

<div class="pre-created-option">
    <ms-betbuilder-pick
        class="pre-created-option-selectable"
        [event]="event"
        [fixtureId]="fixtureId"
        [betBuilderMarket]="market"
        [trackingPosition]="contentPosition"
        [trackingSource]="pickTrackingSource"
        [trackingModuleType]="trackingModuleType"
        [betDetails]="betDetails">
        <ms-font-resizer [defaultSize]="1" [maxChars]="7" [value]="market.option.optionPrice.nativePrice | msNativePriceFormatter" />
    </ms-betbuilder-pick>
</div>

@if (isEditSgpButtonVisible && market.longIds?.length) {
    <ms-betbuilder-edit-pre-created-bab-button [fixtureId]="fixtureId" [event]="event" [market]="market" />
}
